// profile page
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import { ThemeProvider } from '@workboard/wobo-ui';
import ProfileReducer from './reducers/profile.reducers';
import * as ProfileActions from './actions/profile.actions';
import ProfileApp from './components/profile.component';


const mapsStateToPropsProfile = state => ({
  profileData: state,
});

const mapsDispatchToPropsProfile = dispatch => ({
  actions: bindActionCreators(ProfileActions, dispatch),
});

const ProfileAppComp = connect(mapsStateToPropsProfile, mapsDispatchToPropsProfile)(ProfileApp);

const initProfileComp = function (data) {
  const profileStore = createStore(ProfileReducer, data);
  ReactDOM.render(
    <Suspense fallback="loading...">
      <Provider store={profileStore}>
        <ThemeProvider>
          <ProfileAppComp />
        </ThemeProvider>
      </Provider>
    </Suspense>,
    document.getElementById('userProfileComp'),
  );
};

window.initProfileComp = initProfileComp;
